export const PRODUCT_CATEGORIES = {
  Electronics: [
    "Smartphones",
    "Laptops",
    "Accessories",
    "Gaming",
    "Smart Watches",
    "TVs",
  ],

  Clothing: [
    "Men Wear",
    "Women Wear",
    "Hoodies",
    "Jeans",
    "Sneakers",
    "Accessories",
  ],

  Restaurant: [
    "Food",
    "Meals",
    "Seafood",
    "Grilled Items",
    "Snacks",
    "Accompaniments",
    "Drinks",
    "Desserts",
  ],

  Vehicles: [
  "New Cars",
  "Used Cars",
  "Motorcycles",
    "Car Parts",
  "Car Accessories",
],

  Cafe: [
    "Coffee",
    "Tea",
    "Pastries",
    "Light Meals",
    "Cold Drinks",
  ],

  Bakery: [
    "Bread",
    "Cakes",
    "Pastries",
    "Cookies",
  ],

  Grocery: [
    "Fruits",
    "Vegetables",
    "Meat",
    "Seafood",
    "Dairy",
    "Grains",
    "Snacks",
    "Beverages",
  ],

  Beauty: [
    "Skincare",
    "Makeup",
    "Hair Care",
    "Perfumes",
    "Personal Care",
  ],

  Furniture: [
    "Beds",
    "Sofas",
    "Tables",
    "Chairs",
    "Storage",
  ],

  Books: [
    "Fiction",
    "Non-Fiction",
    "Educational",
    "Children",
    "Comics",
  ],

  "Wines & Spirits": [
    "Wine",
    "Whiskey",
    "Beer",
    "Spirits",
  ],

  Bicycle: [
    "Road Bikes",
    "Mountain Bikes",
    "Accessories",
    "Parts",
  ],

  Pharmacy: [
    "Medicines",
    "Supplements",
    "Personal Care",
    "Medical Devices",
  ],

  Toys: [
    "Educational Toys",
    "Action Figures",
    "Puzzles",
    "Outdoor Toys",
  ],

  "Household Store": [
    "Cleaning Supplies",
    "Kitchenware",
    "Storage",
    "Decor",
  ],

  "Shoe Shop": [
    "Men Shoes",
    "Women Shoes",
    "Sneakers",
    "Sandals",
    "Boots",
  ],

  "Creatives Shop": [
    "Art",
    "Handmade Crafts",
    "Design Prints",
    "Custom Work",
  ],
};